export default "__VITE_ASSET__cJAjZUdy__"